import JSZip from 'jszip';
import type { Atlas } from '~/types/atlas';

export async function downloadAtlas(input: {
  canvas: OffscreenCanvas;
  atlas: Atlas;
  manifest: object;
  fileName: string;
}): Promise<void> {
  const blob = await input.canvas.convertToBlob({ type: 'image/png' });
  const zip = new JSZip();
  zip.file('atlas.png', blob);
  zip.file('atlas.json', JSON.stringify(input.atlas, null, 2));
  zip.file('manifest.json', JSON.stringify(input.manifest, null, 2));
  const out = await zip.generateAsync({ type: 'blob' });
  const url = URL.createObjectURL(out);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${input.fileName.replace(/\.\w+$/, '')}.zip`;
  document.body.appendChild(a);
  a.click();
  // Defer cleanup — revoking immediately can cancel the download in some browsers.
  setTimeout(() => {
    a.remove();
    URL.revokeObjectURL(url);
  }, 0);
}
